import { defineMessages } from 'react-intl-next';

// Exposes i18n messages for the search result type component.
export const messages: {
    answer: {
        defaultMessage: string;
        description: string;
        id: string;
    }; attachment: {
        defaultMessage: string;
        description: string;
        id: string;
    }; blogpost: {
        defaultMessage: string;
        description: string;
        id: string;
    }; board: {
        defaultMessage: string;
        description: string;
        id: string;
    }; branch: {
        defaultMessage: string;
        description: string;
        id: string;
    }; calendar: {
        defaultMessage: string;
        description: string;
        id: string;
    }; card: {
        defaultMessage: string;
        description: string;
        id: string;
    }; channel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; comment: {
        defaultMessage: string;
        description: string;
        id: string;
    }; commit: {
        defaultMessage: string;
        description: string;
        id: string;
    }; component: {
        defaultMessage: string;
        description: string;
        id: string;
    }; dashboard: {
        defaultMessage: string;
        description: string;
        id: string;
    }; database: {
        defaultMessage: string;
        description: string;
        id: string;
    }; document: {
        defaultMessage: string;
        description: string;
        id: string;
    }; embed: {
        defaultMessage: string;
        description: string;
        id: string;
    }; filter: {
        defaultMessage: string;
        description: string;
        id: string;
    }; folder: {
        defaultMessage: string;
        description: string;
        id: string;
    }; goal: {
        defaultMessage: string;
        description: string;
        id: string;
    }; issue: {
        defaultMessage: string;
        description: string;
        id: string;
    }; learning: {
        defaultMessage: string;
        description: string;
        id: string;
    }; message: {
        defaultMessage: string;
        description: string;
        id: string;
    }; page: {
        defaultMessage: string;
        description: string;
        id: string;
    }; plan: {
        defaultMessage: string;
        description: string;
        id: string;
    }; presentation: {
        defaultMessage: string;
        description: string;
        id: string;
    }; project: {
        defaultMessage: string;
        description: string;
        id: string;
    }; 'pull-request': {
        defaultMessage: string;
        description: string;
        id: string;
    }; question: {
        defaultMessage: string;
        description: string;
        id: string;
    }; repository: {
        defaultMessage: string;
        description: string;
        id: string;
    }; 'sharepoint-document': {
        defaultMessage: string;
        description: string;
        id: string;
    }; space: {
        defaultMessage: string;
        description: string;
        id: string;
    }; space_calendar: {
        defaultMessage: string;
        description: string;
        // snake_case returned by the API
        id: string;
    }; spreadsheet: {
        defaultMessage: string;
        description: string;
        id: string;
    }; tag: {
        defaultMessage: string;
        description: string;
        id: string;
    }; unrecognised: {
        defaultMessage: string;
        description: string;
        id: string;
    }; whiteboard: {
        defaultMessage: string;
        description: string;
        id: string;
    }; 'work-item': {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	page: {
		id: 'dynamic-cards-search-page.search_result_type_page',
		defaultMessage: 'Page',
		description: 'Label for the page search result type',
	},
	blogpost: {
		id: 'dynamic-cards-search-page.search_result_type_blogpost',
		defaultMessage: 'Blog Post',
		description: 'Label for the blog post search result type',
	},
	whiteboard: {
		id: 'dynamic-cards-search-page.search_result_type_whiteboard',
		defaultMessage: 'Whiteboard',
		description: 'Label for the whiteboard search result type',
	},
	database: {
		id: 'dynamic-cards-search-page.search_result_type_database',
		defaultMessage: 'Database',
		description: 'Label for the database search result type',
	},
	space: {
		id: 'dynamic-cards-search-page.search_result_type_space',
		defaultMessage: 'Space',
		description: 'Label for the space search result type',
	},
	attachment: {
		id: 'dynamic-cards-search-page.search_result_type_attachment',
		defaultMessage: 'Attachment',
		description: 'Label for the attachment search result type',
	},
	comment: {
		id: 'dynamic-cards-search-page.search_result_type_comment',
		defaultMessage: 'Comment',
		description: 'Label for the comment search result type',
	},
	folder: {
		id: 'dynamic-cards-search-page.search_result_type_folder',
		defaultMessage: 'Folder',
		description: 'Label for the folder search result type',
	},
	calendar: {
		id: 'dynamic-cards-search-page.search_result_type_calendar',
		defaultMessage: 'Calendar',
		description: 'Label for the calendar search result type',
	},
	space_calendar: {
		// snake_case returned by the API
		id: 'dynamic-cards-search-page.search_result_type_space_calendar',
		defaultMessage: 'Space calendar',
		description: 'Label for the space calendar search result type',
	},
	question: {
		id: 'dynamic-cards-search-page.search_result_type_question',
		defaultMessage: 'Question',
		description: 'Label for the question search result type',
	},
	answer: {
		id: 'dynamic-cards-search-page.search_result_type_answer',
		defaultMessage: 'Answer',
		description: 'Label for the answer search result type',
	},
	embed: {
		id: 'dynamic-cards-search-page.search_result_type_embed',
		defaultMessage: 'Smart Link',
		description: 'Label for the smart link result type',
	},
	board: {
		id: 'dynamic-cards-search-page.search_result_type_board',
		defaultMessage: 'Board',
		description: 'Label for the board search result type',
	},
	dashboard: {
		id: 'dynamic-cards-search-page.search_result_type_dashboard',
		defaultMessage: 'Dashboard',
		description: 'Label for the dashboard search result type',
	},
	filter: {
		id: 'dynamic-cards-search-page.search_result_type_filter',
		defaultMessage: 'Filter',
		description: 'Label for the filter search result type',
	},
	issue: {
		id: 'dynamic-cards-search-page.search_result_type_issue',
		defaultMessage: 'Issue',
		description: 'Label for the issue search result type',
	},
	plan: {
		id: 'dynamic-cards-search-page.search_result_type_plan',
		defaultMessage: 'Plan',
		description: 'Label for the plan search result type',
	},
	project: {
		id: 'dynamic-cards-search-page.search_result_type_project',
		defaultMessage: 'Project',
		description: 'Label for the project search result type',
	},
	goal: {
		id: 'dynamic-cards-search-page.search_result_type_goal',
		defaultMessage: 'Goal',
		description: 'Label for the goal search result type',
	},
	tag: {
		id: 'dynamic-cards-search-page.search_result_type_tag',
		defaultMessage: 'Tag',
		description: 'Label for the tag search result type',
	},
	learning: {
		id: 'dynamic-cards-search-page.search_result_type_learning',
		defaultMessage: 'Learning',
		description: 'Label for the learning search result type',
	},
	unrecognised: {
		id: 'dynamic-cards-search-page.search_result_type_unrecognised',
		defaultMessage: 'Unrecognised',
		description: 'Label for the unrecognised search result type',
	},
	document: {
		id: 'dynamic-cards-search-page.search_result_type_document',
		defaultMessage: 'Document',
		description: 'Label for the document search result type',
	},
	spreadsheet: {
		id: 'dynamic-cards-search-page.search_result_type_spreadsheet',
		defaultMessage: 'Spreadsheet',
		description: 'Label for the spreadsheet search result type',
	},
	presentation: {
		id: 'dynamic-cards-search-page.search_result_type_presentation',
		defaultMessage: 'Presentation',
		description: 'Label for the presentation search result type',
	},
	'sharepoint-document': {
		id: 'dynamic-cards-search-page.search_result_type_sharepoint_document',
		defaultMessage: 'Sharepoint Document',
		description: 'Label for the sharepoint document search result type',
	},
	message: {
		id: 'dynamic-cards-search-page.search_result_type_message',
		defaultMessage: 'Message',
		description: 'Label for a slack message search result type',
	},
	repository: {
		id: 'dynamic-cards-search-page.search_result_type_repository',
		defaultMessage: 'Repository',
		description: 'Label for a repository search result type',
	},
	'pull-request': {
		id: 'dynamic-cards-search-page.search_result_type_pull_request',
		defaultMessage: 'Pull Request',
		description: 'Label for a pull request search result type',
	},
	commit: {
		id: 'dynamic-cards-search-page.search_result_type_commit',
		defaultMessage: 'Commit',
		description: 'Label for a commit search result type',
	},
	branch: {
		id: 'dynamic-cards-search-page.search_result_type_branch',
		defaultMessage: 'Branch',
		description: 'Label for a branch search result type',
	},
	channel: {
		id: 'dynamic-cards-search-page.search_result_type_channel',
		defaultMessage: 'Channel',
		description: 'Label for a message channel search result type',
	},
	component: {
		id: 'dynamic-cards-search-page.search_result_type_component',
		defaultMessage: 'Component',
		description: 'Label for a component search result type',
	},
	'work-item': {
		id: 'dynamic-cards-search-page.search_result_type_work_item',
		defaultMessage: 'Work Item',
		description: 'Label for a work item search result type',
	},
	card: {
		id: 'dynamic-cards-search-page.search_result_type_card',
		defaultMessage: 'Card',
		description: 'Label for a card search result type',
	},
});
